<template>

  <v-select
      prepend-icon="inventory"
      :items="getItems"
      :item-text="'name'"
      :item-value="'id'"
      v-model="item"
      :label="$t('delivery.stock.labels.items')"
      :loading="loading"
      :error="hasInputErrors('items')"
      :error-messages="getInputErrors('items')"
      color="secondary"
      item-color="secondary"
      :multiple="multiple"
      :chips="chips"
      :rules="otherItems ? uniqueRule : required ? required : null"
  ></v-select>

</template>

<script>

import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'


import ProductProvider from "../../providers/ProductProvider"

export default {
  name: "ProductCombobox",
  mixins: [InputErrorsByProps, RequiredRule],
  props: {
    value: {type: [String, Array]},
    otherItems: {type: Array},
    multiple: {type: Boolean, default: false},
    chips: {type: Boolean, default: false},
    category: {type: String}
  },
  data() {
    return {
      items: [],
      loading: false
    }
  },
  computed: {
    getItems(){
      return this.items.filter(i => i.categories.some(c => c.id == this.category))
    },
    item: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    uniqueRule(){
      return [
          v => !this.otherItems.some(i => i.product === v) || "Producto no puede repetirse"
      ]
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    fetch() {
      this.loading = true
      ProductProvider.fetchProduct().then(r => {
        this.items = r.data.fetchProduct
      }).catch(err => console.error(err))
          .finally(() => this.loading = false)
    }

  }
}
</script>

<style scoped>

</style>

